import { ChangeEvent, useState } from 'react';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { LanguageSkillListType } from 'types/kodawari';

/**
 * 語学に関するカスタムフック
 * @param initialLanguageSkillList
 * @returns 語学の値と更新する関数を含むオブジェクト
 */
export const useLanguageSkillList = (
  initialLanguageSkillList: LanguageSkillListType[]
) => {
  const [languageSkillList, setLanguageSkillList] = useState<
    LanguageSkillListType[]
  >(initialLanguageSkillList);

  const selectedLanguageSkillList = languageSkillList
    .filter(({ isChecked }) => isChecked)
    .map(({ value }) => value);

  // チェック状態更新処理
  const updateIsCheckedLanguageSkillList = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const checkedList = languageSkillList.map((item) => {
      if (item.value !== event.target.value) return item;

      return {
        ...item,
        isChecked: event.target.checked,
      };
    });

    setLanguageSkillList(checkedList);

    return checkedList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value);
  };

  // 求人件数更新処理
  const updateLanguageListJobCount = (
    requirementsJobCountList: JobCountDetailResponse[] | undefined
  ) => {
    setLanguageSkillList((pre) =>
      pre.map((item) => ({
        ...item,
        jobCount: findJobCount(requirementsJobCountList, item.value),
      }))
    );
  };

  // チェック状態クリア処理
  const clearIsCheckedLanguageList = () => {
    const checkedList = languageSkillList.map((item) => {
      return {
        ...item,
        isChecked: false,
      };
    });
    setLanguageSkillList(checkedList);
  };

  return {
    languageSkillList,
    selectedLanguageSkillList,
    updateIsCheckedLanguageSkillList,
    updateLanguageListJobCount,
    clearIsCheckedLanguageList,
  };
};
